<template>
<div v-if="envio">
    <Box @close="close({})" :width="'800px'">
        <template #top>Envio: {{ envio.env_codigo }}</template>
        <template #center>
            <div class="nj-cols">
                <div class="nj-card">
                    <div class="nj-subtitle-1">Cliente</div>
                    <div class="nj-cols form c3">
                        <div>
                            <label class="nj-label">Cliente</label>
                            <input type="text" class="nj-text" disabled v-model="envio.cli_nombre">
                        </div>
                        <div>
                            <label class="nj-label">Dirección</label>
                            <input type="text" class="nj-text" disabled v-model="envio.cde_direccion">
                        </div>
                        <div>
                            <label class="nj-label">Distrito</label>
                            <input type="text" class="nj-text" disabled v-model="envio.ubi_nombre">
                        </div>
                    </div>
                </div>
                <div class="nj-card">
                    <div class="nj-subtitle-1">Envio</div>
                    <div class="nj-cols c2 align-start">
                        <div class="nj-cols">
                            <div>
                                <label class="nj-label">Estado</label>
                                <input type="text" class="nj-text" disabled v-model="envio.est_nombre">
                            </div>
                            <div>
                                <label class="nj-label">Producto</label>
                                <input type="text" class="nj-text" disabled v-model="envio.ovd_producto">
                            </div>
                            <div>
                                <label class="nj-label">Cantidad</label>
                                <input type="text" class="nj-text nj-text-right" disabled v-model="cantidad">
                            </div>
                            <div>
                                <label class="nj-label">Mixer</label>
                                <input type="text" class="nj-text" disabled v-model="envio.mix_nombre">
                            </div>
                        </div>
                        <div class="nj-cols">
                            <div>
                                <label class="nj-label">Fecha entrega</label>
                                <Fecha :data="fecha_envio" :disabled="true" />
                            </div>
                            <div class="nj-cols form c4">
                                <div>
                                    <label class="nj-label">Hora carguio</label>
                                    <Hora :data="hora_carguio" :disabled="true" />
                                </div>
                                <div>
                                    <label class="nj-label">Hora salida</label>
                                    <Hora :data="hora_salida" :disabled="true" />
                                </div>
                                <div>
                                    <label class="nj-label">Hora entrega</label>
                                    <Hora :data="hora_envio" :disabled="true" />
                                </div>
                                <div>
                                    <label class="nj-label">Hora retorno</label>
                                    <Hora :data="hora_retorno" :disabled="true" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="nj-card">
                    <div class="nj-subtitle-1">Historial de estados</div>
                    <br>
                    <b-table :data="envio.lista_historial_estado_envio">
                        <template slot-scope="props">
                            <b-table-column label="Estado" header-class="is-info">{{ props.row.est_nombre }}</b-table-column>
                            <b-table-column label="Fecha registro" header-class="is-info">{{ props.row.hee_fecha_registro }}</b-table-column>
                        </template>
                    </b-table>
                </div>
                <div class="nj-card">
                    <div class="nj-subtitle-1">Guías</div>
                    <br>
                    <div class="nj-flx">
                        <Button label="Generar Guía" icon="add" color="blue" @click="popup({ componente: 'generarGuia', status: true })" :activation="activarGenerarGuia()"></Button>
                        <Button :label="guia.ngu_id" icon="pdf" @click="verGuia(guia)" v-for="guia in envio.lista_nube_fact_guia" :key="guia.ngu_id"></Button>
                    </div>
                </div>
            </div>
        </template>
    </Box>
    <GenerarGuia v-if="activarRegistrarGuia" @close="popup($event)" :env_id="env_id"></GenerarGuia>
</div>
</template>

<script>
import { EstadoEnum } from "../../constants"
import { EnvioService, ResponseStatus } from "../../rest"
import DateTime from "../../util/dateTime"
import Toast from "../../util/toast"
import { Button, Box } from "../components"
import Fecha from "../components/Fecha"
import Hora from "../components/Hora"
import GenerarGuia from "./GenerarGuia.vue"

export default {
    name: "VerEnvio",
    components: {
        Fecha,
        Hora,
        Box,
        Button,
        GenerarGuia,
    },
    props: {
        env_id: {
            type: Number
        }
    },
    data() {
        return {
            envio: null,
            historial_estados: [],
            activarRegistrarGuia: false
        }
    },
    computed: {
        fecha_envio() {
            return DateTime.convertStringToObject(this.envio.env_fecha_hora_envio)
        },
        hora_carguio() {
            return DateTime.convertStringToObject(this.envio.env_fecha_hora_carguio)
        },
        hora_salida() {
            return DateTime.convertStringToObject(this.envio.env_fecha_hora_salida)
        },
        hora_envio() {
            return DateTime.convertStringToObject(this.envio.env_fecha_hora_envio)
        },
        hora_retorno() {
            return DateTime.convertStringToObject(this.envio.env_fecha_hora_retorno)
        },
        cantidad() {
            return `${this.envio.env_cantidad} ${this.envio.unm_simbolo}`
        }
    },
    methods: {
        obtener() {
            const request = {
                envio: {
                    env_id: this.env_id
                }
            }
            EnvioService
                .obtener(request)
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.envio = response.data
                    }
                    else {
                        Toast.warn(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                })
        },
        close({
            componente = "verEnvio",
            status = false,
            renderizar = false
        }) {
            this.$emit("close", {
                componente,
                status,
                renderizar,
            })
        },
        popup({
            componente,
            status,
            renderizar = false,
            ovt_id = null
        }) {
            switch (componente) {
                case "generarGuia":
                    this.activarRegistrarGuia = status
                    break
                default: {
                    this.activarRegistrarGuia = status
                }
            }
            this.ovt_id = ovt_id
            if (renderizar) {
                this.obtener()
            }
        },
        activarGenerarGuia() {
            return this.envio.est_id == EstadoEnum.EN_RUTA.est_id
                && this.envio.lista_nube_fact_guia.length == 0
        },
        verGuia(guia) {
            if (guia.ngu_enlace == null) {
                Toast.warn("La guía de remision remitente " + guia.ngu_id + " aun no ha sido aceptada por SUNAT")
            } else {
                window.open(guia.ngu_enlace, "_blank")
            }
        },
    },
    mounted() {
        this.obtener()
    }
}
</script>

<style scoped></style>